const campaignsActionTypes = {
  FETCH_CAMPAIGNS_LIST: 'FETCH_CAMPAIGNS_LIST',
  FETCH_CAMPAIGNS_LIST_SUCCESS: 'FETCH_CAMPAIGNS_LIST_SUCCESS',
  FETCH_CAMPAIGNS_LIST_FAIL: 'FETCH_CAMPAIGNS_LIST_FAIL',

  FETCH_CAMPAIGN_INFO: 'FETCH_CAMPAIGN_INFO',
  FETCH_CAMPAIGN_INFO_SUCCESS: 'FETCH_CAMPAIGN_INFO_SUCCESS',
  FETCH_CAMPAIGN_INFO_FAIL: 'FETCH_CAMPAIGN_INFO_FAIL',

  FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION: 'FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION',
  FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION_SUCCESS: 'FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION_SUCCESS',
  FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION_FAIL: 'FETCH_ADD_OR_EDIT_CAMPAIGN_SUBMISSION_FAIL',

  SET_CAMPAIGN_DETAILS: 'SET_CAMPAIGN_DETAILS',
};

export default campaignsActionTypes;
